import 'angular';

import { PriceMatrixSettingsCtrl } from './price-matrix.settings';
import { PriceMatrixStates }       from './price-matrix.states.ajs';

angular.module('workshop.priceMatrix', [])
.config(PriceMatrixStates)
.controller('PriceMatrixSettingsCtrl', PriceMatrixSettingsCtrl);